import { PlusSquare, Briefcase, Settings, Search } from "react-feather"
import {
  ADMIN_OPS_ROUTES_GROUP,
  GENERAL_ROUTES_GROUP,
} from "@hooks/useHasPermissions"

const pagesSection = [
  {
    href: "/search",
    icon: Search,
    title: "Member Search",
    allowedRoles: GENERAL_ROUTES_GROUP,
  },
  {
    href: "/prospect/create",
    icon: PlusSquare,
    title: "Create Prospect",
    allowedRoles: GENERAL_ROUTES_GROUP,
  },
  {
    href: "/cases",
    icon: Briefcase,
    title: "Cases",
    allowedRoles: GENERAL_ROUTES_GROUP,
  },
  {
    href: "/ops",
    icon: Settings,
    title: "Account Operations",
    allowedRoles: ADMIN_OPS_ROUTES_GROUP,
    children: [
      {
        href: "/ops/orders/failed",
        title: "Failed Orders",
      },
      {
        href: "/ops/mass_notate",
        title: "Mass Notate",
      },
      {
        href: "/ops/bulk_add_traits",
        title: "Bulk Add Traits",
      },
      {
        href: "/ops/partials",
        title: "Partial Orders",
      },
      {
        href: "/ops/aged_accounts",
        title: "Aged Pending Accounts",
      },
      {
        href: "/ops/rewards",
        title: "Rewards",
      },
    ],
  },
]

export const getNavItems = (userRoles) => {
  const allowedRoles = userRoles.map((role) => role.name)

  const filteredPages = pagesSection.filter((page) => {
    if (!page.allowedRoles) return true
    return page.allowedRoles.some((role) => allowedRoles.includes(role))
  })

  return [
    {
      pages: filteredPages,
    },
  ]
}
